import { reportServerVersion } from "./versionSignal";

export class VersionChecker {
  constructor(private fetchFn: typeof window.fetch, private interval: number) {
    this.scheduleCheck();
  }
  private scheduleCheck(): void {
    setTimeout(async () => {
      try {
        reportServerVersion(await this.getVersion());
        // eslint-disable-next-line no-empty
      } catch {
      } finally {
        this.scheduleCheck();
      }
    }, this.interval);
  }
  private async getVersion(): Promise<string> {
    const response = await this.fetchFn("/api/version");
    return await response.text();
  }
}
